import React, { useContext, useState, ChangeEvent } from 'react';
import {
  Button,
  IconButton,
  Box,
  Typography,
  Container,
  FormControl,
} from '@mui/material';
import UploadButtonIcon from '../../../assets/UploadButtonIcon.svg';
import { ProfileContext } from '../../../context/ProfileContext';
import { useNavigate } from 'react-router-dom';
import StyledButton from '../../../components/Button/Button';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import TopNav from '../../../components/TopNav/TopNav';
import './UploadProfilePic.css';

const UploadProfilePic: React.FC = () => {
  const profileContext = useContext(ProfileContext);
  const [file, setFile] = useState<File | null>(null);
  const [name, setName] = useState<string | undefined>(undefined);

  if (!profileContext) {
    throw new Error('ProfileContext must be used within a ProfileProvider');
  }
  const {
    handleNewProfile,
    newProfile,
    preview,
    handlePreview,
    profileStage,
    handleProfileStage,
  } = profileContext;
  const navigate = useNavigate();
  newProfile.idFront = '';

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { type, files, name: inputName } = event.target;
    setName(inputName);

    if (type === 'file' && files && files.length > 0) {
      const selectedFile = files[0];
      setFile(selectedFile);
      console.log('preview is', URL.createObjectURL(selectedFile));
      handlePreview(URL.createObjectURL(selectedFile));
    }
  };

  const handleUpload = () => {
    if (newProfile.profilePic === '') {
      if (name && file) {
        handleNewProfile({ [name]: file });
        if (preview) {
          handleProfileStage(3);
        } else {
          console.error('No profile picture selected.');
        }
      } else {
        console.error('File or name is missing.');
      }
    } else {
      handleProfileStage(3);
    }
  };

  const handleSkip = () => {
    newProfile.profilePic = '';
    handlePreview(null);
    handleProfileStage(3);
  };

  const backClick = () => {
    if (profileStage !== 1) {
      handleProfileStage(profileStage - 1);
    } else {
      navigate('/signup');
    }
  };

  return (
    <StyledBgContainer>
      <TopNav showArrow={true} backClick={backClick} />
      <Container maxWidth="sm">
        <Box component="form" noValidate autoComplete="off">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              px: { sm: 6 },
            }}
          >
            <Typography
              variant="h6"
              className="heading"
              sx={{
                color: 'white',
                fontFamily: 'Opensans',
                fontWeight: '700',
              }}
            >
              Upload Profile Picture
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'grey', mt: 1, mb: 3, textAlign: 'center' }}
            >
              A profile picture (PFP) is a visual representation of yourself{' '}
               and will be displayed next to your name on your profile and
              chats.
            </Typography>
            <FormControl
              fullWidth
              variant="outlined"
              sx={{ mb: 1, alignItems: 'center' }}
            >
              <Box
                className="upload-container"
                sx={{ width: { xs: '45vw', sm: '35vw', md: '16vw' } }}
              >
                <input
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="upload-button-file"
                  type="file"
                  name="profilePic"
                  onChange={handleChange}
                />
                {!preview && (
                  <>
                    <label htmlFor="upload-button-file">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="span"
                      >
                        <img src={UploadButtonIcon} alt="Upload Icon" />
                      </IconButton>
                    </label>
                    <p className="upload-txt">Upload</p>
                  </>
                )}
                {preview && (
                  <img
                    src={preview}
                    alt="Profile Preview"
                    className="upload-profilepic-preview "
                  />
                )}
              </Box>
            </FormControl>
            <FormControl
              fullWidth
              variant="outlined"
              sx={{
                gap: 3,
                mt: 5,
                mb: 3,
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
              }}
            >
              <Button
                sx={{
                  borderRadius: '38px',
                  border: '1.4px solid',
                  width: '130px',
                  height: '43px',
                  textTransform: 'none',
                  color: 'rgba(54, 95, 145, 1)',
                  fontFamily: 'Opensans',
                  fontWeight: '700',
                }}
                variant="outlined"
                onClick={handleSkip}
              >
                Skip
              </Button>

              <StyledButton
                variant="contained"
                color="primary"
                sx={{
                  width: '130px',
                  height: '43px',
                  borderRadius: '38px',
                  textTransform: 'none',
                }}
                onClick={handleUpload}
                disabled={!preview}
              >
                Continue
              </StyledButton>
            </FormControl>
          </Box>
        </Box>
      </Container>
    </StyledBgContainer>
  );
};

export default UploadProfilePic;
